import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {FormGroup} from "@angular/forms";
import {
  PagamentoUnipayRequest, PagoPaResponse,
  PaymentNoticesRequest,
  PaymentNoticesResponse
} from "../models/payment-notices-response";

@Injectable({
  providedIn: 'root'
})
export class PaymentnoticesService {
  url: string;
  urlPagoPa: string;
  mapCodiceTributo: Map<string, string>;

  constructor(private httpClient: HttpClient) {
    this.url = "services/pnoticeshandler/pnotices/";
    this.urlPagoPa = "services/pagopahandler/pagopa/";
    this.mapCodiceTributo = new Map<string, string>([
      ["LV", "Lampade Votive"],
      ["TB", "Rifiuti"],
      ["IM", "Tributi IMU"],
      ["TB", "TARI"],
      ["TX", "TASI"],
      ["CU", "Canone Unico Patrimoniale"],
      ["AQ", "Canone Idrico"],
      ["MUL","Contravvenzioni"]
    ])
  }

  getPaymentNotices(form: PaymentNoticesRequest): Observable<PaymentNoticesResponse>{
    return this.httpClient.post<PaymentNoticesResponse>(this.url + 'getPaymentNotices', form);
  }

  getPagoPaRedirectUrl(form: PagamentoUnipayRequest): Observable<PagoPaResponse>{
    return this.httpClient.post<PagoPaResponse>(this.urlPagoPa + 'getPagoPaRedirectUrl', form);
  }
}
